import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";


export default function App({ slides, open, setOpen }: any) {
    let result = new Array(slides.length).fill({ src: "", alt: "" })
    slides.map((slide: { src: string, alt: string }, index: number) => {
        result[index].src = `/products/mini_karta/${slide.src}`;
        result[index].alt = slide.alt
    })

    return (
        <>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                plugins={[Thumbnails, Zoom]}
                zoom={{ maxZoomPixelRatio: 4 }}
                slides={result}
            />
        </>
    );
}
